import React from "react"

export function IntercomDisabledAlert() {
  return (
    <div className="alert alert-info">
      <strong className="flex items-center mb-2">
        <svg
          className="mr-1"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="currentColor"
        >
          <path d="M12 6.75a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0v-5a.75.75 0 0 1 .75-.75zM11.15 16a.851.851 0 1 1 .85.85.85.85 0 0 1-.85-.85z"></path>
          <path
            fillRule="evenodd"
            d="M2.25 12A9.75 9.75 0 0 1 12 2.25 9.75 9.75 0 0 1 21.75 12 9.75 9.75 0 0 1 12 21.75 9.75 9.75 0 0 1 2.25 12zM12 3.75A8.25 8.25 0 0 0 3.75 12 8.25 8.25 0 0 0 12 20.25 8.25 8.25 0 0 0 20.25 12 8.25 8.25 0 0 0 12 3.75z"
            clipRule="evenodd"
          ></path>
        </svg>
        Maintenance notice
      </strong>
      Our main support channel is currently down for maintenance. If you need
      help, please reach out to <a href="mailto:help@kit.com">help@kit.com</a>.
    </div>
  )
}
